import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

export class ConcessaoSearch{
    nrPlaca: string;
    nrPrefixo: number;
    nrOrdem: string;
    nrPonto: string;
    cdConcessionario: number;
    nrConcessao: string;
    nrCpfCnpj: string;
    nmUsuario: string;
    cdLinha: number;
    cdMotoristaAuxiliar: number;
    stConcessao: number;
    stConcessaoVeiculo: number;
    limit: number;
    page: number;
    cdPessoa: number;
    dtInicioConcessao: Date;
    dtFinalConcessao: Date;
    tpConcessao: number;
    nmConcessionario: string;
    nmPessoa: string;
    idPonto: string;
    nrParada: string;

    constructor(data:{
        nrPlaca?:string,
        nrPrefixo?:number,
        nrOrdem?:string,
        nrPonto?:string,
        nmUsuario?:string,
        cdConcessionario?:number,
        nrConcessao?:string,
        nrCpfCnpj?:string,
        cdLinha?:number,
        cdMotoristaAuxiliar?:number,
        stConcessao?:number,
        stConcessaoVeiculo?:number,
        cdPessoa?: number,
        tpConcessao?: number,
        dtInicioConcessao?: Date,
        dtFinalConcessao?: Date,
        nmConcessionario?: string,
        nmPessoa?: string,
        idPonto?: string,
        nrParada?: string,
        limit?:number,
        page?:number
        })
            {
            this.nrPlaca = data && data.nrPlaca;
            this.nrPrefixo = data && data.nrPrefixo;
            this.nrOrdem = data && data.nrOrdem;
            this.nrPonto = data && data.nrPonto;
            this.cdConcessionario = data && data.cdConcessionario;
            this.nrConcessao = data && data.nrConcessao;
            this.nrCpfCnpj = data && data.nrCpfCnpj;
            this.cdLinha = data && data.cdLinha;
            this.cdMotoristaAuxiliar = data && data.cdMotoristaAuxiliar;
            this.stConcessao = data && data.stConcessao;
            this.stConcessaoVeiculo = data && data.stConcessaoVeiculo;
            this.cdPessoa = data && data.cdPessoa;
            this.tpConcessao = data && data.tpConcessao;
            this.dtInicioConcessao = data && data.dtInicioConcessao;
            this.dtFinalConcessao = data && data.dtFinalConcessao;
            this.nmConcessionario = data && data.nmConcessionario;
            this.nmPessoa = data && data.nmPessoa;
            this.idPonto = data && data.idPonto;
            this.nrParada = data && data.nrParada;
            this.limit = data && data.limit;
            this.nmUsuario = data && data.nmUsuario;
            }

    getFilters():IFilter{
        let filtros:IFilter = new HttpFilter([]);

        if(this.nrPlaca){
            filtros.addFilter(new Equal('nrPlaca', this.nrPlaca));
        }  
        
        if(this.nmUsuario){
            filtros.addFilter(new Equal('nmUsuario', this.nmUsuario));
        }
        
        if(this.nrPrefixo){
            filtros.addFilter(new Equal('nrPrefixo', this.nrPrefixo));
        }
        
        if(this.nrOrdem){
            filtros.addFilter(new Equal('nrOrdem', this.nrOrdem));
        }
        
        if(this.nrPonto){
            filtros.addFilter(new Equal('nrPonto', this.nrPonto));
        }

        if(this.cdConcessionario){
            filtros.addFilter(new Equal('cdConcessionario', this.cdConcessionario));
        }            

        if(this.nrConcessao){
            filtros.addFilter(new Equal('nrConcessao', this.nrConcessao));
        }

        if(this.nrCpfCnpj){
            filtros.addFilter(new Equal('nrCpfCnpj', this.nrCpfCnpj));
        }

        if(this.cdLinha){
            filtros.addFilter(new Equal('cdLinha', this.cdLinha));
        }

        if(this.cdMotoristaAuxiliar){
            filtros.addFilter(new Equal('cdMotoristaAuxiliar', this.cdMotoristaAuxiliar));
        }            
   
        if(this.nmConcessionario!= null){
            filtros.addFilter(new Equal('nmConcessionario', this.nmConcessionario));
        }

        if(this.tpConcessao != -1 && this.tpConcessao != null ){
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));
        }
        
        if(!isNaN(this.stConcessao) && this.stConcessao != null){
            filtros.addFilter(new Equal('stConcessao', this.stConcessao));
        } 

        if(!isNaN(this.stConcessaoVeiculo) && this.stConcessaoVeiculo!=null){
            filtros.addFilter(new Equal('stConcessaoVeiculo', this.stConcessaoVeiculo));
        }

        if(this.dtInicioConcessao){
            filtros.addFilter(new Equal('dtInicioConcessao', this.dtInicioConcessao));
        }

        if(this.dtFinalConcessao){
            filtros.addFilter(new Equal('dtFinalConcessao', this.dtFinalConcessao));
        }

        if(this.nmPessoa){
            filtros.addFilter(new Equal('nmPessoa', this.nmPessoa));
        }  

        if(this.idPonto){
            filtros.addFilter(new Equal('idPonto', this.idPonto));
        }  

        if(this.nrParada){
            filtros.addFilter(new Equal('nrParada', this.nrParada));
        }     

        if(this.page){
            filtros.addFilter(new Equal('page', this.page));
        } 

        if(this.limit){
            filtros.addFilter(new Equal('limit', this.limit));
        }

        return filtros;
    }
}
